import { FC } from 'react';
import s from './OptionListModal.module.css';
import { Modal } from 'components/common/Modal/Modal';
import { SelectableOption } from 'components/common/OptionSelector/OptionSelector';

type OptionListModalProps = {
  title: string;
  options: SelectableOption[];
  selectedId: string;
  onSelect: (id: string) => void;
  onBack: () => void;
  onClose: () => void;
};

export const OptionListModal: FC<OptionListModalProps> = ({
  title,
  options,
  selectedId,
  onSelect,
  onBack,
  onClose,
}) => {
  return (
    <Modal title={title} onClose={onClose} onBack={onBack}>
      <div className={s['container']}>
        {options.map((option) => (
          <button
            key={option.id}
            type='button'
            className={s['option']}
            data-selected={option.id === selectedId}
            aria-pressed={option.id === selectedId}
            onClick={() => onSelect(option.id)}
          >
            {option.name}
          </button>
        ))}
      </div>
    </Modal>
  );
};
